/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Grid, Paper } from "@material-ui/core";
import EnrollmentCountBarChart from "./enrollmentCountChart/enrollmentCountBarChart/EnrollmentCountBarChart";
import EnrollmentCountPieChart from "./enrollmentCountChart/enrollmentCountPieChart/EnrollmentCountPieChart";

const CoreEnrollmentCountChart = ({ enrollCountData }) => {
	return (
		<Grid container spacing={1}>
			<Grid item xs={4} sm={6} md={7} lg={7} xl={7}>
				<Grid container className="pf-grid-container">
					<Paper className="pf-paper-container" elevation={3} variant="outlined">
						<div className="overview-sub-header">Core Plan Enrollment Overview</div>
						<div className="enrollment-count-chart-container" style={{ marginTop: "8px" }}>
							<EnrollmentCountBarChart data={enrollCountData} />
						</div>
					</Paper>
				</Grid>
			</Grid>
			<Grid item xs={4} sm={6} md={5} lg={5} xl={5}>
				<Grid container className="pf-grid-container">
					<Paper className="pf-paper-container" elevation={3} variant="outlined">
						<div className="overview-sub-header">Core Plan Enrollment Overview</div>
						<div className="enrollment-count-chart-container" style={{ marginTop: "8px" }}>
							<EnrollmentCountPieChart data={enrollCountData} />
						</div>
					</Paper>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default CoreEnrollmentCountChart;
